import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { IFormStyles } from "../../styles";
import { useControlStyles } from "./controlStyles";
import { useSectionStyles } from "./sectionStyles";

export const useFormStyles = (theme?: ITheme): IFormStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        section: {
            ...useSectionStyles(theme)
        },
        control: {
            ...useControlStyles(theme),
        }
    }
}